import _ from 'lodash'
import userApi from '@/api/user'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    userApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  block({ commit }, id) {
    return userApi.block({ id })
      .then(() => commit('USER_BLOCKED', id))
      .catch(error => {
        commit('USER_BLOCK_FAILED', { id, errors: error.response.data.errors })
        throw error
      })
  },
  activate({ commit }, id) {
    return userApi.activate({ id })
      .then(() => commit('USER_ACTIVATED', id))
      .catch(error => {
        commit('USER_ACTIVATION_FAILED', { id, errors: error.response.data.errors })
        throw error
      })
  },
  updateRole({ commit }, { id, role }) {
    return userApi.updateRole({ id, role })
      .then(() => commit('USER_ROLE_UPDATED'))
      .catch(error => {
        commit('USER_ROLE_UPDATE_FAILED', error.response.data.errors)
        throw error
      })
  },

  resetPassword(context, id) {
    return userApi.resetPassword({ id })
      .then(({ data }) => data.password)
      .catch(error => {
        store.dispatch('message/error', 'Не удалось выдать пароль')
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  USER_ACTIVATED(state, id) {
    store.dispatch('user/fetchList')
    store.dispatch('message/success', 'USER.success')
  },
  USER_ACTIVATION_FAILED(state, { id, errors }) {
    store.dispatch('message/error', 'USER.activationFailure')
    state.errors = errors
  },
  USER_BLOCKED(state, id) {
    store.dispatch('user/fetchList')
    store.dispatch('message/success', 'USER.success')
  },
  USER_BLOCK_FAILED(state, { id, errors }) {
    store.dispatch('message/error', 'USER.blockFailure')
    state.errors = errors
  },
  USER_ROLE_UPDATED() {
    store.dispatch('user/fetchList')
    store.dispatch('message/success', 'Роль изменена')
  },
  USER_ROLE_UPDATE_FAILED(state, errors) {
    store.dispatch('message/error', 'Не удалось сменить роль')
    state.errors = errors
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [state => state.user.filters, _.debounce(async () => await store.dispatch('user/fetchList'), 250), { immediate: false, deep: true }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
